// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1Smrs","container_1":"container_1___3pSkD","container_2":"container_2___Zc4Ll"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Vendor/styles.module.scss
// module id = 735
// module chunks = 0